import { baseApi } from "../../../../core/data/rtk/baseQuery";
import { ApiResponseType } from "../../../../core/data/rtk/apiResponseType";
import { BatchTimingResponseType, Data } from "../types/batchTimingResponse";
import { BatchTimingPayloadType } from "../types/batchTimingRequest";

export const batchTimingApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllBatchTiming: builder.query<
      ApiResponseType<Data>,
      { size?: number; search?: string; page?: number }
    >({
      query: (params) => {
        const queryParams = new URLSearchParams();
        if (params?.size) queryParams.append("size", params.size.toString());
        if (params?.search) queryParams.append("search", params.search);
        if (params?.page) queryParams.append("page", params.page.toString());

        return `batches/get-all?${queryParams.toString()}`;
      },
      providesTags: ["BatchTiming"],
    }),
    addBatchTiming: builder.mutation<
      ApiResponseType<{ batchTiming: BatchTimingResponseType }>,
      BatchTimingPayloadType
    >({
      query: (payload) => ({
        url: "batches/save",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["BatchTiming"],
    }),
    getBatchTimingById: builder.query<
      ApiResponseType<{ batch: BatchTimingResponseType }>,
      { id: string }
    >({
      query: ({ id }) => `batches/get/${id}`,
      providesTags: (result, error, { id }) => [{ type: 'BatchTiming', id }],
    }),
    updateBatchTiming: builder.mutation<
      ApiResponseType<{ batchTiming: BatchTimingResponseType }>,
      { id: string; payload: BatchTimingPayloadType }
    >({
      query: ({ id, payload }) => ({
        url: `batches/update/${id}`,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["BatchTiming"],
    }),
    deleteBatchTiming: builder.mutation<
      ApiResponseType<{ deleted: true }>,
      { id: string }
    >({
      query: ({ id }) => ({
        url: `batches/delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["BatchTiming"],
    }),
  }),
});

export const {
  useGetAllBatchTimingQuery,
  useAddBatchTimingMutation,
  useGetBatchTimingByIdQuery,
  useUpdateBatchTimingMutation,
  useDeleteBatchTimingMutation,
} = batchTimingApi;
